import React from 'react';
import { Box, Typography, Stack, Link, useTheme, useMediaQuery } from '@mui/material';
import TradingViewMiniChart from './TradingViewMiniChart';

const charts = [
  'FX:EURUSD',
  'NASDAQ:AAPL',
  'BINANCE:BTCUSDT',
  'OANDA:GBPUSD',
  'FOREXCOM:USDJPY',
  'BINANCE:ETHUSDT',
];

const ChartsPreview = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ width: '100%' }}>
      {/* HEADER */}
      <Box
        sx={{
          p: 2,
          border: {
            xs: 'none',
            sm: '1px solid #e0e0e0'
          },
          borderRadius: {
            xs: 0,
            sm: 2
          },
          bgcolor: {
            xs: 'white',
            sm: '#f5f5f5'
          },
          mb: 2,
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Stack
          direction="row"
          justifyContent={{ xs: 'center', sm: 'space-between' }}
          alignItems="center"
        >
          <Typography
            variant="h6"
            fontWeight="bold"
            textAlign={{ xs: 'center', sm: 'left' }}
          >
             <Link href="/markets" underline="hover" color="text.primary">
             Charts
            </Link>
          </Typography>

          {!isMobile && (
            <Link href="/markets" underline="always" color="text.primary">
              See more
            </Link>
          )}
        </Stack>
      </Box>

      {/* GRID*/}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, minmax(0, 1fr))',
          },
          gap: 4,
          alignItems: 'stretch',
          justifyItems: 'stretch',
        }}
      >
        {charts.map((symbol) => (
          <Box
            key={symbol}
            sx={{
              width: '100%',
              border: '1px solid #ddd',
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
              p: 1,
              boxSizing: 'border-box',
            }}
          >
            <TradingViewMiniChart symbol={symbol} width="100%" height={150} />
          </Box>
        ))}
      </Box>

      {isMobile && (
        <Box
          mt={2}
          textAlign="center"
          sx={{
            pb: { xs: 6, sm: 0 }
          }}
        >
          <Link href="/markets" underline="always" color="text.primary">
            See more
          </Link>
        </Box>
      )}
    </Box>
  );
};

export default ChartsPreview;
